var watchlistSelector = {
	label: "Choose Watchlist",
	validationErrors: {
		selectWatchlist: "You must select a watchlist"
	}
};
var en = {
	watchlistSelector: watchlistSelector
};

export { en as default, watchlistSelector };
